<template>
  <a
    :class="isMobile ? 'mobile' : 'pc'"
    class="popup"
    :href="href"
    @mouseover="isMobile || open()"
    @mouseout="isMobile || hide()"
    @click="isMobile && change()"
    target="_blank"
  >
    <img :src="icon" v-show="!hovericon || !show">
    <img :src="hovericon" v-show="hovericon && show">
    <div v-if="code" v-show="show">
      <img :src="code">
    </div>
  </a>
</template>

<script>

export default {
  props: ['icon', 'hovericon', 'href', 'code'],
  data () {
    return {
      show: false,
      isMobile: false
    }
  },
  methods: {
    open () {
      this.show = true
    },
    hide () {
      this.show = false
    },
    change () {
      this.show = !this.show
    }
  }
}
</script>

<style scoped>
.popup {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 12px;
}

.popup > img {
  width: 100%;
  height: 100%;
}

.popup.pc {
  position: relative;
}

.popup.pc div {
  width: 142px;
  position: absolute;
  left: 50%;
  top: -12px;
  transform: translateX(-50%) translateY(-100%);
}

.popup.pc div img {
  width: 100%;
  height: 100%;
}

.popup.mobile div {
  position: fixed;
  left: 0;
  top: 66px;
  padding-bottom: 66px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
}

.popup.mobile div img {
  width: 50%;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin-top: -66px;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/index.vue